import { Component } from '@angular/core';

import { config } from "../../../../../config/index";

@Component({
    selector: 'ortho-footer',
	template: require('./ortho-footer.component.html'),
	styles: [require('./ortho-footer.component.less')],
	providers: [],
})

export class OrthoFooterComponent {

	termsOfUseUrl = config.termsOfUseUrl;
	privacyPolicyUrl = config.privacyPolicyUrl;
	orthoCatapultUrl: string = config.orthoCatapultUrl;

	constructor() { }

	openInNewTab(option: any) {
		if (option === 'privacy') {
			window.open(this.privacyPolicyUrl, '_blank', '');
		} else if (option === 'terms') {
			window.open(this.termsOfUseUrl, '_blank', '');
		} else if (option === 'ortho') {
			window.open(this.orthoCatapultUrl, '_blank', '');
		}
	}
}